import { Subject, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
@Injectable()

export class AppService {
    constructor(
        public router: Router
    ) { }
    userNameSource = new Subject<any>();
    updatedUserName$ = this.userNameSource.asObservable();
    companyLogoSource = new BehaviorSubject<any>('');
    updatedCompanyLogo$ = this.companyLogoSource.asObservable();
    navigationStateSource = new Subject<any>();
    updatedNavigationState$ = this.navigationStateSource.asObservable();
    userProfileImageSource = new BehaviorSubject<any>('');
    updatedUserProfileImage$ = this.userProfileImageSource.asObservable();
    companyDataSource = new BehaviorSubject<any>({});
    updatedCompanyData$ = this.companyDataSource.asObservable();
    userDataSource = new BehaviorSubject<any>({});
    updatedUserData$ = this.userDataSource.asObservable();
    countryCodeSource = new BehaviorSubject<any>('');
    updatedCompanyCode$ = this.countryCodeSource.asObservable();
    levelSource = new BehaviorSubject<any>('');
    updatedLevels$ = this.levelSource.asObservable();
    treeSource = new Subject();
    updatedTree$ = this.treeSource.asObservable();
    deleteNodeSource = new Subject();
    deleteNode$ = this.deleteNodeSource.asObservable();
    switchUserSource = new Subject();
    switchUser$ = this.switchUserSource.asObservable();
    updateCompanyMenu = new BehaviorSubject<boolean>(false);
    companyMenu$ = this.updateCompanyMenu.asObservable();
    errorSubject = new Subject<void>();
    getErrorSubject = this.errorSubject.asObservable();
    loggingInSubject = new Subject<void>();
    getLoggingInSubject = this.loggingInSubject.asObservable();
    updateWidthForReporting = new Subject<boolean>();
    pageScrollingSubject = new BehaviorSubject<boolean>(true);
    pageScrollingSubject$ = this.pageScrollingSubject.asObservable();
    openLoyaltyNumberScanner = new Subject<boolean>();
    updateLoyaltyNumberSearchInputSubject = new BehaviorSubject<string | null>(null);
    getUpdateLoyaltyNumberSearchInputSubject$ = this.updateLoyaltyNumberSearchInputSubject.asObservable();
    visibleLoyaltySearchInputs = new BehaviorSubject<boolean>(false);
    loyaltySearchInputs = new Subject();
    headerReloadClick = new Subject<void>();
    getHeaderReloadClick$ = this.headerReloadClick.asObservable();

    /**
     * To update tree node data
     * @param data Node data
     */
    updateNode(data) {
        this.deleteNodeSource.next(data);
    }

    updateCompanyMenuItems(updateItems: boolean) {
        this.updateCompanyMenu.next(updateItems);
    }

    changeSwitchUserState() {
        this.switchUserSource.next(false);
    }

    redirectToLogin() {
        localStorage.clear();
        this.changeSwitchUserState();
        this.router.navigate(['/login']);
    }

    /**
     * To update tree
     * @param data Tree data
     */
    updateTree(data) {
        this.treeSource.next(data);
    }

    /**
     * To share level data between components
     * @param data Levels data
     */
    updateLevels(data) {
        this.levelSource.next(data);
    }

    /**
     * To update user name in the header
     * @param data Updated Name
     */
    updateUserName(data) {
        this.userNameSource.next(data);
    }

    /**
     * To update company logo in the sidebar
     * @param data Updated Logo
     */
    updateCompanyLogo(data) {
        this.companyLogoSource.next(data);
    }

    /**
     * To update navigation state
     * @param data Updated state
     */
    updateNavState(data) {
        this.navigationStateSource.next(data);
    }

    /**
     * To update user profile image in header
     * @param data Updated image url
     */
    updateUserProfileImage(data) {
        this.userProfileImageSource.next(data);
    }

    /**
     * To share company data between sidebar and company settings page
     * @param data Company Data
     */
    updateCompanyData(data) {
        this.companyDataSource.next(data);
    }

    /**
     * To share user profile data between header and user profile page
     * @param data User profile data
     */
    updateUserData(data) {
        this.userDataSource.next(data);
    }

    /**
     * To update user name in the header
     * @param data Updated Name
     */

    /**
     * To update the language based on country code
     * @param data Language to display
     */
    updateCountryCode(data) {
        this.countryCodeSource.next(data);
    }

    /**
     * To update the skeleton loaders state on error
     */
    notifyError() {
        this.errorSubject.next();
    }

    loggingIn() {
        this.loggingInSubject.next();
    }

}

